module.exports = __webpack_public_path__ + "media/images/flags/4x3/nor-c1784c5e2b8f7694b2fd3e3c3bcf2e8c.svg";